import React, { useEffect, useState } from "react";
import { Typography, Container, Grid } from "@material-ui/core";
import SettingOption from "../components/homes/SettingOption";
import { useTranslation } from "../langs/useTranslation";
import useStyles from "../styles/homeStyle";
import goodviewIcon from "../assets/images/goodview.svg";
import nubisIcon from "../assets/images/nubis.svg";
import storeIcon from "../assets/svgs/store.svg";
import announcementIcon from "../assets/svgs/announcement.svg";
import vergoIcon from "../assets/images/vergo.svg";
import visioIcon from "../assets/images/visio.svg";
import updateCenterIcon from "../assets/images/package-center.svg";
import personalizedManagementIcon from "../assets/images/personalized-management.svg";
import viscoveryIcon from "../assets/images/viscovery.svg";
import * as localforage from "localforage";
import { getCountriesAPI } from "../apis/getCountriesAPI";
import { getRegionsAPI } from "../apis/getRegionsAPI";
import { updateNotificationAPI } from "@/apis/updateNotificationAPI";
import {
  getNubisLink,
  getVisioLink,
  getVergoLink
} from "../helpers/getServicesLink";
import { getGoodviewLink } from "../helpers/getGoodviewLink";
import LoadingIndicator from "../components/commons/LoadingIndicator";
import HasPermission from "../components/commons/HasPermission";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import {
  IconAccountCenter,
  IconDevicesGroups,
  IconSubscribeService,
  IconAccessManagement
} from "../components/Icon";
import Cookies from "js-cookie";
import Marquee from "react-fast-marquee";
import { Alert } from "antd";
import { IconAnnouncement2 } from "@/components/Icon";
import { getNubisDomain } from "@/helpers/utils";
import { APP_ENV } from "@/APP_ENV";
import CustomImage from "@/components/Image";

const Home = () => {
  const classes = useStyles();
  const { t, langConf } = useTranslation("home");
  const [userName, setUserName] = useState();
  const [userInfo, setUserInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [announcement, setAnnouncement] = useState(null);

  // to test service icons have correctly shown up, just change the variable value to the desired DNS name.
  const dnsName = window.location.origin;
  const getUsername = async () => {
    const storedUser = await localforage.getItem("user");
    if (storedUser) {
      setUserName(storedUser.name);
      setUserInfo(storedUser);
    }
  };

  const handleGetNubisLink = async () => {
    setIsLoading(true);
    const result = await getNubisLink();
    if (result) {
      setIsLoading(!!result);
    }
  };

  const handleViscovery = () => {
    window.open("https://vcms.viscovery.com/web/login");
  };

  const getUpdateCenterLink = () => {
    window.open(APP_ENV.REACT_APP_UPDATE_CENTER_URL);
  };

  const handleGetGoodviewLink = () => {
    getGoodviewLink();
  };

  const handleGetVisioLink = async () => {
    setIsLoading(true);
    const result = await getVisioLink();
    if (result) {
      setIsLoading(!!result);
    }
  };

  const handleGetVergoLink = async () => {
    setIsLoading(true);
    const result = await getVergoLink();
    if (result) {
      setIsLoading(!!result);
    }
  };

  const storedRegionsAndCountriesToLocal = async () => {
    getRegionsAPI();
    getCountriesAPI();
  };

  useEffect(() => {
    storedRegionsAndCountriesToLocal();
    getUsername();
  }, []);

  useEffect(() => {
    window.__diyFunction__setAnnouncement = setAnnouncement;
    setAnnouncement(window.__diyFunction__announcement);
  }, []);

  return isLoading ? (
    <div className={classes.wholePageLoading}>
      <LoadingIndicator />
    </div>
  ) : (
    <div className={classes.root}>
      <Container maxWidth="lg" className={classes.container}>
        {Boolean(announcement) && announcement?.isScroll && (
          <Alert
            banner
            closable
            onClose={async () => {
              await updateNotificationAPI([
                window.__diyFunction__announcement_notificationId
              ]);
              if (window.__diyFunction__announcement_refresh)
                window.__diyFunction__announcement_refresh();
            }}
            style={{
              borderRadius: 5,
              marginTop: -45,
              marginBottom: 45,
              backgroundColor: "rgba(247,134,42,0.2)",
              color: "#F7862A"
            }}
            showIcon
            icon={<IconAnnouncement2 color="#F7862A" />}
            message={
              // announcement?.isScroll ? (
              <Marquee
                pauseOnHover
                gradient={false}
                style={{ color: "#F7862A" }}
              >
                {announcement.title}: {announcement.message}
              </Marquee>
              // ) : (
              //   <span style={{ color: "#F7862A" }}>
              //     {announcement.title}: {announcement.message}
              //   </span>
              // )
            }
          />
        )}
        <div className={classes.welcomeText}>
          <Typography variant="h3">
            {t("welcome.text")}
            {userName}
          </Typography>
          <Typography variant="subtitle1">
            {langConf.platform?.introduce || t("welcome.description")}
          </Typography>
        </div>
        <Grid container spacing={3} className={classes.optionsWrap}>
          <HasPermission permission="Account Center">
            <SettingOption
              linkPath="/account-center"
              btnTitle={langConf.platform?.accountCenterText || t("settingOptionText.ac_title")}
              btnText={langConf.platform?.accountCenterTip || t("settingOptionText.ac_description")}
              icon={<CustomImage s3Path={langConf.platform?.accountCenterIcon} renderCompo={<IconAccountCenter />} />}
              imgAlt={t("settingOptionText.ac_imgAlt")}
            />
          </HasPermission>
          <HasPermission permission="Devices & Groups">
            {/*<SettingOption*/}
            {/*  linkPath="/devices-groups"*/}
            {/*  btnTitle={t("settingOptionText.dg_title")}*/}
            {/*  btnText={t("settingOptionText.dg_description")}*/}
            {/*  icon={<IconDevicesGroups />}*/}
            {/*  imgAlt={t("settingOptionText.dg_imgAlt")}*/}
            {/*/>*/}
            <SettingOption
              linkPath="/company-device"
              btnTitle={langConf.platform?.deviceManagementText ? langConf.platform.deviceManagementText : t("settingOptionText.dg_title")}
              btnText={langConf.platform?.deviceManagementTip ? langConf.platform.deviceManagementTip : t("settingOptionText.dg_description")}
              icon={<CustomImage s3Path={langConf.platform?.deviceManagementIcon} renderCompo={<IconDevicesGroups />} />}
              imgAlt={t("settingOptionText.dg_imgAlt")}
            />
          </HasPermission>
          {/* <HasPermission permission="Subscribe Services">
            <SettingOption
              linkPath="/subscriptions"
              btnTitle={t("settingOptionText.ss_title")}
              btnText={t("settingOptionText.ss_description")}
              icon={<IconSubscribeService />}
              imgAlt={t("settingOptionText.ss_imgAlt")}
            />
          </HasPermission> */}
          <HasPermission permission="Merchant Management">
            <SettingOption
              linkPath="/store-management"
              btnTitle={langConf.platform?.merchantManagementText ? langConf.platform.merchantManagementText : t({ defaultMessage: "门店管理" })}
              btnText={langConf.platform?.merchantManagementTip ? langConf.platform.merchantManagementTip : t({ defaultMessage: "门店和账户管理" })}
              imgSrc={storeIcon}
              imgS3Path={langConf.platform?.merchantManagementIcon}
              imgAlt={t({ defaultMessage: "门店和账户管理" })}
            />
          </HasPermission>
          <HasPermission permission="Access Management">
            <SettingOption
              linkPath="/access-management"
              btnTitle={langConf.platform?.accessManagementText ? langConf.platform.accessManagementText : t("settingOptionText.am_title")}
              btnText={langConf.platform?.accessManagementTip ? langConf.platform.accessManagementTip : t("settingOptionText.am_description")}
              icon={<CustomImage s3Path={langConf.platform?.accessManagementIcon} renderCompo={<IconAccessManagement />} />}
              imgAlt={t("settingOptionText.am_imgAlt")}
            />
          </HasPermission>
          {/*<SettingOption*/}
          {/*  linkPath="/user-management"*/}
          {/*  btnTitle={t({ defaultMessage: "账号管理" })}*/}
          {/*  btnText={t({defaultMessage:"一些门店用户列表的介绍"})}*/}
          {/*  icon={<AssignmentIndIcon />}*/}
          {/*  imgAlt={t("serviceOptionText.nb_imgAlt")}*/}
          {/*/>*/}
          {/* Nubis */}
          <SettingOption
            linkPath="/"
            btnTitle={langConf.platform?.deviceCenterText ? langConf.platform.deviceCenterText : t({ defaultMessage: "设备中心" })}
            btnText={langConf.platform?.deviceCenterTip ? langConf.platform.deviceCenterTip : t("settingOptionText.nubis_description")}
            //imgSrc={nubisIcon}
            // icon={
            //   langConf.platform?.deviceCenterIcon? <img src={langConf.platform?.deviceCenterIcon} />:
            //   <img
            //     src={nubisIcon}
            //     style={{ marginBottom: "21px", width: "110px" }}
            //     alt={t("serviceOptionText.nb_imgAlt")}
            //   />
            // }
            icon={<CustomImage s3Path={langConf.platform?.deviceCenterIcon} renderCompo={<img
              src={nubisIcon}
              style={{ marginBottom: "21px", width: "110px" }}
              alt={t("serviceOptionText.nb_imgAlt")}
            />} />}
            clickBtn={e => {
              e.preventDefault();
              window.location.replace(getNubisDomain());
            }}
            imgAlt={t("serviceOptionText.nb_imgAlt")}
          />

          {(userInfo?.company?.parent_company_id === "" ||
            userInfo?.company?.parent_company_id === null) && (
              <HasPermission permission="System Notices Services">
                <SettingOption
                  linkPath="/announcement"
                  btnTitle={langConf.platform?.announcementManagementText ? langConf.platform.announcementManagementText : t({ defaultMessage: "公告管理" })}
                  btnText={langConf.platform?.announcementManagementTip ? langConf.platform.announcementManagementTip : t({ defaultMessage: "维护系统公共通知" })}
                  imgSrc={announcementIcon}
                  imgS3Path={langConf.platform?.announcementManagementIcon}
                  imgAlt={t("settingOptionText.ac_imgAlt")}
                />
              </HasPermission>
            )}

          {/* Visio */}
          {/* {dnsName === "https://fec-platform.com.cn" ? (
            <SettingOption
              linkPath="/"
              btnTitle="Visio"
              className="disabledBtn"
              imgSrc={visioIcon}
              imgAlt={t("serviceOptionText.vg_imgAlt")}
            />
          ) : (
            <SettingOption
              linkPath="/"
              btnTitle="Visio"
              imgSrc={visioIcon}
              clickBtn={handleGetVisioLink}
              imgAlt={t("serviceOptionText.vg_imgAlt")}
            />
          )} */}

          {/* Vergo */}
          {/* <ServiceOption
            linkPath="/"
            btnTitle="Vergo"
            className="disabledBtn"
            imgSrc={vergoIcon}
            imgAlt={t("serviceOptionText.vs_imgAlt")}
          />  */}
          {/* {dnsName !== "https://fec-platform.fecpos.com" &&
            (dnsName === "https://fec-platform.com.cn" ? (
              <SettingOption
                linkPath="/"
                btnTitle="Vergo"
                className="disabledBtn"
                imgSrc={vergoIcon}
                imgAlt={t("serviceOptionText.vs_imgAlt")}
              />
            ) : (
              <SettingOption
                linkPath="/"
                btnTitle="Vergo"
                imgSrc={vergoIcon}
                clickBtn={handleGetVergoLink}
                imgAlt={t("serviceOptionText.vg_imgAlt")}
              />
            ))} */}

          {/* Viscovery */}
          {/* {dnsName !== "https://fec-platform.com.cn" && (
            <SettingOption
              linkPath="/"
              btnTitle="Viscovery"
              className=""
              imgSrc={viscoveryIcon}
              clickBtn={handleViscovery}
              imgAlt={t("serviceOptionText.vi_imgAlt")}
            />
          )} */}

          {/* Goodview */}
          {/* {dnsName !== "https://fec-platform.fecpos.com" && (
            <SettingOption
              linkPath="/"
              btnTitle="Goodview"
              className=""
              clickBtn={handleGetGoodviewLink}
              imgSrc={goodviewIcon}
              imgAlt={t("serviceOptionText.gv_imgAlt")}
            />
          )} */}

          {/* Nubis Update Center */}
          {(userInfo?.company?.parent_company_id === "" ||
            userInfo?.company?.parent_company_id === null) && (APP_ENV.REACT_APP_UPDATE_CENTER_ENABLE) && (
              <HasPermission permission="Update Center">
                <SettingOption
                  linkPath="/"
                  btnTitle={langConf.platform?.updateCenterText ? langConf.platform.updateCenterText : t({ defaultMessage: "更新中心" })}
                  btnText={langConf.platform?.updateCenterTip ? langConf.platform.updateCenterTip : t("settingOptionText.uc_description")}
                  imgSrc={updateCenterIcon}
                  imgS3Path={langConf.platform?.updateCenterIcon}
                  clickBtn={getUpdateCenterLink}
                  imgAlt={t("serviceOptionText.pc_imgAlt")}
                />
              </HasPermission>
            )}

          <HasPermission permission="Personalized Management">
            <SettingOption
              linkPath="/personalized-management"
              btnTitle={langConf.platform?.personalizedManagementText ? langConf.platform.personalizedManagementText : t({ defaultMessage: "个性化管理" })}
              btnText={langConf.platform?.personalizedManagementTip ? langConf.platform.personalizedManagementTip : t({ defaultMessage: "允许用户轻松自定义网站标题、图标和文本，以获得个性化的网络体验" })}
              imgSrc={personalizedManagementIcon}
              imgS3Path={langConf.platform?.personalizedManagementIcon}
              imgAlt={t({ defaultMessage: "个性化管理" })}
            />
          </HasPermission>
        </Grid>
        {/* <Typography variant="h5" align="center">
          {t("serviceOptionText.section_title")}
        </Typography>
        <Grid container spacing={3} className={classes.optionsWrap}>
        </Grid> */}
      </Container>
    </div>
  );
};

export default Home;
